// extracted by mini-css-extract-plugin
export var card = "case-study-card-module--card--5-uEE";
export var categories = "case-study-card-module--categories--mTF1c";
export var category = "case-study-card-module--category--NTK1B";
export var content = "case-study-card-module--content--5AOOS";
export var info = "case-study-card-module--info--QBor1";
export var services = "case-study-card-module--services--qQ+ux";
export var title = "case-study-card-module--title--90Qvd";